export default __webpack_public_path__ + "images/82c64165b884bded639b2d60e59a24e8-randb_small.webp";